import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { AuthWrapper } from './AuthWrapper';
import App from './App';
import { NotificationProvider, FeatureFlagProvider } from 'utils';

const app = (
	<Provider store={store}>
		<BrowserRouter>
			<AuthWrapper>
				<NotificationProvider>
					<FeatureFlagProvider>
						<App />
					</FeatureFlagProvider>
				</NotificationProvider>
			</AuthWrapper>
		</BrowserRouter>
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
